interface RectLike {
    top: number;
    left: number;
    width: number;
    height: number;
}

interface SizeLike {
    width: number;
    height: number;
}

const TOOLBAR_GAP_PX = 8;

const clamp = (value: number, min: number, max: number): number =>
    Math.min(Math.max(value, min), max);

export const resolveHoveringToolbarContainer = ({
    overlayContainer,
    overlayContainerEl,
}: {
    overlayContainer: HTMLElement | null;
    overlayContainerEl: HTMLElement | null | undefined;
}): HTMLElement => overlayContainer ?? overlayContainerEl ?? document.body;

export const getHoveringToolbarOffset = ({
    selectionRect,
    containerRect,
    toolbarSize,
    isPageBody,
}: {
    selectionRect: RectLike;
    containerRect: RectLike;
    toolbarSize: SizeLike;
    isPageBody: boolean;
}): { top: number; left: number } => {
    const originTop = isPageBody ? 0 : containerRect.top;
    const originLeft = isPageBody ? 0 : containerRect.left;
    const selectionTop = selectionRect.top - originTop;
    const selectionLeft = selectionRect.left - originLeft;

    const preferredTop = selectionTop - toolbarSize.height - TOOLBAR_GAP_PX;
    const flippedTop = selectionTop + selectionRect.height + TOOLBAR_GAP_PX;
    let top = preferredTop < 0 ? flippedTop : preferredTop;
    let left = selectionLeft - toolbarSize.width / 2 + selectionRect.width / 2;

    if (containerRect.width > 0) {
        left = clamp(
            left,
            0,
            Math.max(0, containerRect.width - toolbarSize.width),
        );
    }

    if (containerRect.height > 0) {
        top = clamp(
            top,
            0,
            Math.max(0, containerRect.height - toolbarSize.height),
        );
    }

    return { top, left };
};

export const showHoveringToolbar = ({
    element,
    container,
    selectionRect,
}: {
    element: HTMLElement;
    container: HTMLElement;
    selectionRect: DOMRect;
}): void => {
    const isPageBody = container === document.body;
    const { top, left } = getHoveringToolbarOffset({
        selectionRect,
        containerRect: isPageBody
            ? {
                  top: 0,
                  left: 0,
                  width: window.innerWidth,
                  height: window.innerHeight,
              }
            : container.getBoundingClientRect(),
        toolbarSize: {
            width: element.offsetWidth,
            height: element.offsetHeight,
        },
        isPageBody,
    });
    element.style.opacity = "1";
    element.style.visibility = "visible";
    element.style.pointerEvents = "auto";
    element.style.top = `${top}px`;
    element.style.left = `${left}px`;
};

export const hideHoveringToolbar = (element: HTMLElement): void => {
    element.style.opacity = "0";
    element.style.visibility = "hidden";
    element.style.pointerEvents = "none";
    element.style.top = "0px";
    element.style.left = "0px";
};
